/**
 * The Merge jar's open-top U: straight sides, rounded bottom corners. It is the physics inner
 * silhouette (wall faces and floor, with the tier-0 radius on the corners so a resting cell is
 * never hidden), shared by the baked cartoon jar, Pixi Graphics fallbacks and the Canvas 2D path.
 * Re-exported by render/shake-jar-visual.js.
 */

export function clampJarURadius(r, w, h) {
  return Math.max(0, Math.min(r || 0, (w || 0) / 2, h || 0));
}

/**
 * Trace an open-top U (straight sides, rounded bottom). `g` is a canvas ctx or
 * Pixi Graphics (moveTo / lineTo / quadraticCurveTo).
 * @param {{ moveTo: Function, lineTo: Function, quadraticCurveTo: Function, closePath?: Function }} g
 * @param {boolean} [closeTop] close across the mouth so the shape can fill
 */
export function traceJarUPath(g, x, top, w, h, r, closeTop) {
  var width = Math.max(1, w || 1);
  var height = Math.max(1, h || 1);
  var corner = clampJarURadius(r, width, height);
  var bottom = top + height;
  g.moveTo(x, top);
  g.lineTo(x, bottom - corner);
  g.quadraticCurveTo(x, bottom, x + corner, bottom);
  g.lineTo(x + width - corner, bottom);
  g.quadraticCurveTo(x + width, bottom, x + width, bottom - corner);
  g.lineTo(x + width, top);
  if (closeTop) {
    if (typeof g.closePath === "function") g.closePath();
    else g.lineTo(x, top);
  }
}
